import { useCallback, useEffect } from 'react';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { setLoading } from '../../../store/slices/UI';

const useFetch = ([, apiMethod]) => {
  const { isLoading, isSuccess, data: queryData, mutate, isError, error } = useMutation(params => apiMethod(...params), { retry: 0 });

  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  }, [dispatch, isLoading]);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      if (error) {
        console.log('GET ERROR', error);
        console.log('GET ERROR', error.response);
      }
    }
  }, [error, queryData]);

  let localSuccess = isSuccess;
  let localError = isError;
  let data = null;
  if (queryData) {
    data = queryData.body;
    localSuccess = isSuccess && queryData.statusCode === 200;
    localError = !localSuccess;
  }

  const sendRequest = useCallback(
    (...params) => {
      mutate(params);
    },
    [mutate]
  );

  return {
    isSuccess: localSuccess,
    isError: localError,
    error,
    sendRequest,
    data,
    errorMessage: error?.response.data.message || error?.response.data.body || error?.message,
	  statusCode: error?.response.status
  };
};

export default useFetch;
